import React from 'react';

// Generic helper to keep SVGs consistent
const SvgIcon = ({ children, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {children}
  </svg>
);

export const DashboardIcon = ({ className }) => (
  <SvgIcon className={className}>
    <rect x="3" y="3" width="7" height="7" rx="2" />
    <rect x="14" y="3" width="7" height="5" rx="2" />
    <rect x="14" y="11" width="7" height="10" rx="2" />
    <rect x="3" y="13" width="7" height="8" rx="2" />
  </SvgIcon>
);

export const UsersIcon = ({ className }) => (
  <SvgIcon className={className}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </SvgIcon>
);

export const DocumentIcon = ({ className }) => (
  <SvgIcon className={className}>
    <path d="M7 2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
    <path d="M14 2v5h5" />
    <path d="M9 13h6" />
    <path d="M9 17h4" />
  </SvgIcon>
);

export const LockIcon = ({ className }) => (
  <SvgIcon className={className}>
    <rect x="4" y="10" width="16" height="10" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    <circle cx="12" cy="15" r="1.4" />
  </SvgIcon>
);

export const GroupIcon = ({ className }) => (
  <SvgIcon className={className}>
    <path d="M3 21V8l4-3 4 3v13" />
    <path d="M13 21V8l4-3 4 3v13" />
    <path d="M3 10h8" />
    <path d="M13 10h8" />
    <path d="M7 14h2" />
    <path d="M17 14h2" />
  </SvgIcon>
);

export const BuildingIcon = ({ className }) => (
  <SvgIcon className={className}>
    <rect x="3" y="4" width="14" height="16" rx="2" />
    <path d="M7 8h2" />
    <path d="M11 8h2" />
    <path d="M7 12h2" />
    <path d="M11 12h2" />
    <path d="M19 10v10" />
    <path d="M19 14h2" />
    <path d="M9 20v-3h2v3" />
  </SvgIcon>
);

export const SettingsIcon = ({ className }) => (
  <SvgIcon className={className}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.78 1.78 0 0 0 .38 2l.06.06a1.5 1.5 0 0 1-2.12 2.12l-.06-.06a1.78 1.78 0 0 0-2-.38 1.78 1.78 0 0 0-1 1.61V21a1.5 1.5 0 0 1-3 0v-.09A1.78 1.78 0 0 0 10 19.3a1.78 1.78 0 0 0-2 .38l-.06.06a1.5 1.5 0 1 1-2.12-2.12l.06-.06a1.78 1.78 0 0 0 .38-2 1.78 1.78 0 0 0-1.61-1H4a1.5 1.5 0 0 1 0-3h.09A1.78 1.78 0 0 0 5.7 10a1.78 1.78 0 0 0-.38-2l-.06-.06a1.5 1.5 0 0 1 2.12-2.12l.06.06a1.78 1.78 0 0 0 2 .38h.01A1.78 1.78 0 0 0 11 2.39V2a1.5 1.5 0 0 1 3 0v.09a1.78 1.78 0 0 0 1 1.61h.01a1.78 1.78 0 0 0 2-.38l.06-.06a1.5 1.5 0 0 1 2.12 2.12l-.06.06a1.78 1.78 0 0 0-.38 2 1.78 1.78 0 0 0 1.61 1H22a1.5 1.5 0 0 1 0 3h-.09a1.78 1.78 0 0 0-1.61 1Z" />
  </SvgIcon>
);

export const IdCardIcon = ({ className }) => (
  <SvgIcon className={className}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <circle cx="9" cy="11" r="2" />
    <path d="M6.5 15a3.5 3.5 0 0 1 5 0" />
    <path d="M14 9h4" />
    <path d="M14 13h3" />
  </SvgIcon>
);

export const CalendarIcon = ({ className }) => (
  <SvgIcon className={className}>
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <path d="M3 9h18" />
    <path d="M9 13h2v2H9z" />
    <path d="M13 13h2v2h-2z" />
  </SvgIcon>
);

export const ChartIcon = ({ className }) => (
  <SvgIcon className={className}>
    <path d="M3 21h18" />
    <rect x="5" y="10" width="3" height="7" rx="1" />
    <rect x="10.5" y="7" width="3" height="10" rx="1" />
    <rect x="16" y="4" width="3" height="13" rx="1" />
  </SvgIcon>
);

export const ApiIcon = ({ className }) => (
  <SvgIcon className={className}>
    <path d="M4 7h4v10H4z" />
    <path d="M10 17l2-10 2 10" />
    <path d="M9 12h6" />
    <circle cx="19" cy="12" r="3" />
  </SvgIcon>
);

export const LogoutIcon = ({ className }) => (
  <SvgIcon className={className}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </SvgIcon>
);

export const ArrowLeftIcon = ({ className }) => (
  <SvgIcon className={className}>
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </SvgIcon>
);






